import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const ListAllRoomsApi = createAsyncThunk('chat-room/rooms',  async ({ mainUserId, business_id, page = 1, limit = 10, roomType = 'active' }, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/chat-room/room-by-agentId?mainUserId=${mainUserId}&business_id=${business_id}&page=${page}&limit=${limit}&roomType=${roomType}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
}
);


const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const ListRooms = createSlice(
  {
    name: 'ListUserRooms',
    initialState,
    reducers: {},
    extraReducers: {
      [ListAllRoomsApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [ListAllRoomsApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [ListAllRoomsApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default ListRooms;
